export default __webpack_public_path__ + "static/AmericanaBT-Italic-da221b1be9965e8a5881dbd9528a60e6.woff2";